<template>
    <div class="saved-filter" v-show="enabled">
        <div v-if="!formOpened">
            <select v-model="selectedFilter" @change="loadFilter(selectedFilter)" class="form-control">
                <option value="0">{{ t('Select') }}</option>
                <option v-for="item in savedFilters" v-bind:value="item.id">{{ item.name }}</option>
            </select>
            <button @click="openForm()" class="btn btn-success btn-sm">+</button>
        </div>

        <div v-if="formOpened">
            <input type="text" v-model="name" class="form-control user-filter-value">
            <button @click="save(name)" class="btn btn-success btn-sm">{{ t('Save') }}</button>
            <a href="#" @click="closeForm()" class="btn btn-success btn-link">{{ t('Cancel') }}</a>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        componentFilterIndex: {
            type: String
        },
        eventBus: {
            Type: Object,
        },
        routeName: {
            type: String
        },
    },
    data() {
        return {
            events: [],
            enabled: false,
            module: null,
            savedFilters: [],
            selectedFilter: 0,
            formOpened: false,
            name: '',
            defaultValues: [],
            currentValues: [],
            componentFilterFullIndex: ''
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    mounted() {
        this.mountEvents();
    },
    methods: {
        mountEvents() {
            this.eventBus.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
                this.events.push(customModuleEventName);
                let eventName = `${moduleIndex}-${this.componentFilterIndex}:filter-change`;
                this.componentFilterFullIndex = `${moduleIndex}-${this.componentFilterIndex}`;
                this.eventBus.$once(eventName, (filterName, filterValue, filter, filters, params) => {
                    this.defaultValues = this.readFilterValues(filters || []);
                });
                this.eventBus.$on(eventName, (filterName, filterValue, filter, filters, params) => {
                    this.currentValues = this.readFilterValues(filters || []);
                });
                this.events.push(eventName);
            });
            this.events.push('CustomModule:ready');
            this.loadFilters();
        },
        loadFilters() {
            this.$http.get('process-invoke/user-filter-value-load/execute', {params: {module: this.routeName}}).then(response => {
                this.enabled = true;
                this.savedFilters = response.data.data;
            });
        },

        loadFilter(selectedFilterId) {
            if ('0' === selectedFilterId) {
                this.eventBus.$emit(`${this.componentFilterFullIndex}:setState`, this.defaultValues);
                return;
            }

            this.$http.get('process-invoke/user-filter-value-get-values/execute', {params: {id: selectedFilterId}}).then(response => {
                this.eventBus.$emit(`${this.componentFilterFullIndex}:setState`, response.data);
            });
        },

        openForm() {
            this.formOpened = true;
        },

        closeForm() {
            this.formOpened = false;
        },

        save(name) {
            const data = {
                name: name,
                values: this.currentValues,
                module: this.routeName
            };

            this.$http.post('process-invoke/user-filter-value-save/execute', data).then(response => {
                this.loadFilters();
                this.name = '';
                this.closeForm();
            });
        },

        readFilterValues(filters) {
            let values = [];

            filters.forEach((f) => {
                values.push({
                    'name': f.name,
                    'value': f.value
                })
            });

            return values;
        },
        unmountEvents() {
            this.events.forEach(e => {
                this.eventBus.$off(e);
            });
        },
    },
}
</script>

<style lang="css">
.saved-filter {
    padding-right: 10px;
    margin-top: -9px;
}

select.form-control, input.user-filter-value {
    width: 180px;
    display: inline;
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// FilterValue.vue?5fbe1fde